import { render, staticRenderFns } from "./getInsinfoView.vue?vue&type=template&id=4651da5e&scoped=true&"
import script from "./getInsinfoView.vue?vue&type=script&lang=js&"
export * from "./getInsinfoView.vue?vue&type=script&lang=js&"
import style0 from "./getInsinfoView.vue?vue&type=style&index=0&id=4651da5e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4651da5e",
  null
  
)

export default component.exports